import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Angular component used to display quick statistics.
 */
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'edt-quick-stats',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="quick-stats__item" [ngStyle]="containerStyle">
      <ng-content select="[prefix]"></ng-content>
      <div [ngClass]="'quick-stats__info' + (reverse ? ' reverse' : '')">
        <h2 [ngStyle]="counterStyle">{{ prefix }}{{ counter }}{{ suffix }}</h2>
        <small [ngStyle]="descriptionStyle">{{ description }}</small>
      </div>

      <ng-content select="[sufix]"></ng-content>
    </div>
  `,
  styleUrls: ['./quick-stats.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuickStatsComponent {
  /**
   * The value to be displayed as the counter.
   */
  @Input() counter: number | string = 0;

  /**
   * The text to be displayed as the description.
   */
  @Input() description: string | null = '';

  /**
   * A boolean indicating whether to reverse the order of the counter and description.
   */
  @Input() reverse = false;

  /**
   * The suffix to be added to the counter.
   */
  @Input() suffix: string | null = '';

  /**
   * The prefix to be added to the counter.
   */
  @Input() prefix: string | null = '';

  /**
   * An object containing custom styles for the counter.
   */
  @Input() counterStyle: { [style: string]: string } = {};

  /**
   * An object containing custom styles for the description.
   */
  @Input() descriptionStyle: { [style: string]: string } = {};

  /**
   * An object containing custom styles for the container.
   */
  @Input() containerStyle: { [style: string]: string } = {};
}
